/** Locale-agnostic path for the Cookie Settings page. */
export const COOKIE_SETTINGS_PATH = '/cookie-settings' as const;

/** localStorage key for analytics cookie consent. */
export const COOKIES_ANALYTICS_CONSENT_KEY = 'birdlife-analytics-consent' as const;

export const COOKIES_CONSENT_VALUE = {
  granted: 'granted',
  denied: 'denied',
} as const;

export type CookiesConsentValue =
  (typeof COOKIES_CONSENT_VALUE)[keyof typeof COOKIES_CONSENT_VALUE];

/**
 * Full consent record persisted as JSON under `COOKIES_ANALYTICS_CONSENT_KEY`.
 * Legacy entries may be a plain `"granted"` / `"denied"` string (no id/date).
 */
export type CookiesConsentRecord = {
  consent: CookiesConsentValue;
  /** Null for legacy plain-string storage until the user changes consent. */
  id: string | null;
  /** ISO timestamp; null for legacy plain-string storage. */
  decidedAt: string | null;
};

/** Dispatched on `window` after the user accepts or rejects analytics cookies. */
export const COOKIES_CONSENT_CHANGE_EVENT = 'birdlife:analytics-consent-change' as const;

/** BirdLife Privacy Policy (linked from Cookie Settings declaration). */
export const PRIVACY_POLICY_URL = 'https://www.birdlife.org/privacy-policy/' as const;

export const COOKIE_CATEGORY = {
  analytics: 'analytics',
} as const;

export type CookieCategory = (typeof COOKIE_CATEGORY)[keyof typeof COOKIE_CATEGORY];

/** Stable IDs for GA4 cookies listed on the Cookie Settings page. */
export const GA4_COOKIE_ID = {
  ga: 'ga',
  gaMeasurement: 'gaMeasurement',
} as const;

export type Ga4CookieId = (typeof GA4_COOKIE_ID)[keyof typeof GA4_COOKIE_ID];
